// Make overflowing code boxes reachable for native keyboard scrolling.
const codeBoxes = document.querySelectorAll('.rte pre');
const updateCodeBox = (box) => {
  if (box.scrollWidth > box.clientWidth) {
    box.tabIndex = 0;
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Scrollable code example');
  } else {
    box.removeAttribute('tabindex');
    box.removeAttribute('role');
    box.removeAttribute('aria-label');
  }
};
codeBoxes.forEach(updateCodeBox);
if ('ResizeObserver' in window) {
  const observer = new ResizeObserver((entries) => entries.forEach(({ target }) => updateCodeBox(target)));
  codeBoxes.forEach((box) => observer.observe(box));
}
